export default __webpack_public_path__ + "static/media/DinosaursCarnivores_07.a85eebe1.png";